import { render, staticRenderFns } from "./customOrderList.vue?vue&type=template&id=73aca256&scoped=true"
import script from "./customOrderList.vue?vue&type=script&lang=js"
export * from "./customOrderList.vue?vue&type=script&lang=js"
import style0 from "./customOrderList.vue?vue&type=style&index=0&id=73aca256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aca256",
  null
  
)

export default component.exports